// extracted by mini-css-extract-plugin
export default {"card-wrapper":"CreateFontCard_card-wrapper__QG6Cw","card-inner-wrapper":"CreateFontCard_card-inner-wrapper__GoUaf","card-plus":"CreateFontCard_card-plus__cu91O"};